import React from 'react';
import trendbg from './assets/images/trend-bg.png';
import trend1 from './assets/images/trend-1.png';
import trend2 from './assets/images/trend-2.png';
import trend3 from './assets/images/trend-3.png';
import trend4 from './assets/images/trend-4.png';
import user4 from './assets/images/user-4.png';
import user2 from './assets/images/user-2.png';
import user3 from './assets/images/user-3.png';
import user1 from './assets/images/user-1.png'
import verifiedIcon from './assets/images/verified-icon.svg';
// import Carousel from 'react-elastic-carousel';
import { Splide, SplideSlide } from '@splidejs/react-splide';
const Streamers = () => {
  return (
    // <!-- Streamers -->
    <section id="streamers" className="streamers section">
      <div
        className="bg__holder"
        style={{ background: `url(${trendbg})`, backgroundSize: 'cover' }}
      ></div>

      {/* <!--// bg__holder  --> */}
      <div className="container">
        <p className="section__para one" data-aos="fade-up">#GOSTREAM</p>
        <h2 className="heading__1" data-aos="fade-up">Trending Streamers</h2>
        <p className="section__para two" data-aos="fade-up">
          Hang-out with your favorite streamers!
        </p>


      

{/*  Small Devices  */}
<section aria-label="Streamers slider">
              <div className="splide__track">
                <ul className="splide__list gap-3">
                <Splide
      options={ {
        rewind: true,
        width : 700,
        gap   : '1rem',
      } }
    className="mx-auto">

<li className="splide__slide">
                    <div className="card streamer-box" data-aos="fade-up">
                      <a href="#" className="strech__link"></a>
                      <div className="card-img-top">
                        <img
                          src={trend4}
                          alt="Streamer"
                          width="397"
                          height="264"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-body">
                        <div className="user">
                          <span className="user__icon">
                            <img
                              src={user4}
                              alt="user"
                              width="90"
                              height="135"
                              className="img-fluid"
                            />
                          </span>
                          <p className="streamer__tag">Content Creator</p>
                        </div>
                        <div className="title">
                          <h5 className="card-title">Dr. Crypto Vendor</h5>
                          <img
                            src={verifiedIcon}
                            alt="Verified"
                            width="16"
                            height="16"
                            className="img-fluid"
                          />
                        </div>
                        <p className="card-text">
                          100k followers • 20k Premium Subscribers
                        </p>
                      </div>
                    </div>
                  </li>
                
                  <li className="splide__slide">
                    <div className="card streamer-box" data-aos="fade-up">
                      <a href="#" className="strech__link"></a>
                      <div className="card-img-top">
                        <img
                          src={trend2}
                          alt="Streamer"
                          width="397"
                          height="264"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-body">
                        <div className="user">
                          <span className="user__icon">
                            <img
                              src={user2}
                              alt="user"
                              width="90"
                              height="135"
                              className="img-fluid"
                            />
                          </span>
                          <p className="streamer__tag">Gamer/Creator</p>
                        </div>
                        <div className="title">
                          <h5 className="card-title">Michael</h5>
                          <span className="is-live">LIVE</span>
                        </div>
                        <p className="card-text">
                          10k followers • 5k Premium Subscribers
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="splide__slide">
                    <div className="card streamer-box" data-aos="fade-up">
                      <a href="#" className="strech__link"></a>
                      <div className="card-img-top">
                        <img
                          src={trend3}
                          alt="Streamer"
                          width="397"
                          height="264"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-body">
                        <div className="user">
                          <span className="user__icon">
                            <img
                              src={user3}
                              alt="user"
                              width="90"
                              height="135"
                              className="img-fluid"
                            />
                          </span>
                          <p className="streamer__tag">Content Creator</p>
                        </div>
                        <div className="title">
                          <h5 className="card-title">Dr. Crypto Vendor</h5>
                          <img
                            src={verifiedIcon}
                            alt="Verified"
                            width="16"
                            height="16"
                            className="img-fluid"
                          />
                        </div>
                        <p className="card-text">
                          100k followers • 20k Premium Subscribers
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="splide__slide">
                    <div className="card" data-aos="fade-up">
                      <a href="#" className="strech__link"></a>
                      <div className="card-img-top">
                        <img
                          src={trend1}
                          alt="Streamer"
                          width="397"
                          height="264"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-body">
                        <div className="user">
                          <span className="user__icon">
                            <img
                              src={user1}
                              alt="user"
                              width="90"
                              height="135"
                              className="img-fluid"
                            />
                          </span>
                          <p className="streamer__tag">Gamer/Creator</p>
                        </div>
                        <div className="title">
                          <h5 className="card-title">Janine</h5>
                          <span className="is-live">LIVE</span>
                        </div>
                        <p className="card-text">
                          50k followers • 15k Premium Subscribers
                        </p>
                      </div>
                    </div>
                  </li>
                
                  </Splide>
                  </ul>
              </div>
</section>


        
        <div className="load-more">
          <a href="#" className="you-btn">Browse</a>
        </div>
      </div>
    </section>
    // <!-- Streamers -->
  );
};

export default Streamers;